var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import UndoIcon from '@mui/icons-material/Undo';
import { Box, Button, Typography } from '@mui/material';
import React, { useState } from 'react';
import { enqueueSnackbar } from 'notistack';
import { ListProvider, useList, } from '../../../components/Pagination/ListContext';
import { WizardButtons } from '../../../components/Wizard/WizardButtons';
import { useWizard } from '../../../components/Wizard/useWizard';
import { useProcessEdicaoContext } from '../context/ProcessEdicaoContext';
import { OperadorModalForm } from '../../../components/Operador/OperadorModalForm';
import { RequestLoadingIndicator } from '../../../components/RequestLoadingIndicator';
import { RenderList } from '../../../components/Pagination/RenderList';
import { searchOperadorEdicao, removeOperadorEdicaoInProcesso, revertOperadorExclusion, } from '../../../services/processo-operador-edicao.service';
import { formatCpf } from '../../../util/masks';
import { FilterComponent } from '../../../components/Pagination/FilterComponent';
import { OrderComponent } from '../../../components/Pagination/OrderComponent';
import { StatusEdicaoTag } from '../../../components/StatusEdicaoTag';
import { useDialog } from '../../../hooks/useDialog';
import { StatusEdicaoEnum } from '../../../enums/status-edicao.enum';
import { GrupoCampoAnalise, StatusItemAnalise, } from '../../../enums/analise.enum';
var filterFields = [
    { label: 'Nome', name: 'nome', type: 'text' },
    { label: 'CPF', name: 'cpf', type: 'text' },
];
export var OperadoresForm = function (_a) {
    var _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    var _c = useWizard(), nextStep = _c.nextStep, prevStep = _c.prevStep;
    var _d = useProcessEdicaoContext(), servico = _d.servico, processo = _d.processo;
    if (!(servico === null || servico === void 0 ? void 0 : servico.exigeOperador)) {
        return null;
    }
    var handleSearchItems = function (filters, params) {
        if (!(processo === null || processo === void 0 ? void 0 : processo.processoEdicaoId)) {
            return Promise.resolve({
                page: 1,
                pageSize: 10,
                total: 0,
                items: [],
            });
        }
        return searchOperadorEdicao(processo.processoEdicaoId, filters, params);
    };
    return (_jsx(ListProvider, { fetchItems: handleSearchItems, filterFields: filterFields, children: _jsx(OperadoresListContent, { disabled: disabled, nextStep: nextStep, prevStep: prevStep }) }));
};
var OperadoresListContent = function (_a) {
    var disabled = _a.disabled, nextStep = _a.nextStep, prevStep = _a.prevStep;
    var refresh = useList().refresh;
    var _b = useState(null), modalOperadorOpen = _b[0], setModalOperadorOpen = _b[1];
    var _c = useState(), selectedOperador = _c[0], setSelectedOperador = _c[1];
    var _d = useState(false), loading = _d[0], setLoading = _d[1];
    var confirm = useDialog().confirm;
    var _e = useProcessEdicaoContext(), addOperador = _e.addOperador, updateOperador = _e.updateOperador, processo = _e.processo, analise = _e.analise;
    var getStatus = function (operador) {
        var _a;
        if (!analise) {
            return null;
        }
        var statusGrupo = (_a = analise === null || analise === void 0 ? void 0 : analise.gruposCampos) === null || _a === void 0 ? void 0 : _a.find(function (g) {
            return g.entidade === 'OPERADOR' &&
                g.entidadeAssociadaId === operador.id &&
                g.grupo === GrupoCampoAnalise.DADOS_GERAIS;
        });
        if (statusGrupo) {
            if (statusGrupo.status === StatusItemAnalise.APROVADO) {
                return { status: 'success', message: 'Aprovado' };
            }
            else if (statusGrupo.status === StatusItemAnalise.REPROVADO) {
                return { status: 'error', message: 'Reprovado' };
            }
        }
        return { status: 'info', message: 'Aguardando análise' };
    };
    var handleOpenAdd = function () {
        setSelectedOperador(undefined);
        setModalOperadorOpen('adicionar');
    };
    var handleOpenEdit = function (operador) {
        setSelectedOperador(operador);
        setModalOperadorOpen('editar');
    };
    var handleOpenView = function (operador) {
        setSelectedOperador(operador);
        setModalOperadorOpen('visualizar');
    };
    var handleCloseModal = function () {
        setModalOperadorOpen(null);
        setSelectedOperador(undefined);
    };
    var handleDelete = function (operador) { return __awaiter(void 0, void 0, void 0, function () {
        var confirmed, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, confirm({
                        title: 'Confirmar Exclusão',
                        content: "Tem certeza que deseja excluir o operador \"".concat(operador.nome, "\"?"),
                        confirmationText: 'Excluir',
                        cancellationText: 'Cancelar',
                    })];
                case 1:
                    confirmed = _b.sent();
                    if (!confirmed) {
                        return [2 /*return*/];
                    }
                    _b.label = 2;
                case 2:
                    _b.trys.push([2, 4, 5, 6]);
                    setLoading(true);
                    return [4 /*yield*/, removeOperadorEdicaoInProcesso(processo.processoEdicaoId, operador.id)];
                case 3:
                    _b.sent();
                    enqueueSnackbar('Operador excluído com sucesso!', { variant: 'success' });
                    refresh();
                    return [3 /*break*/, 6];
                case 4:
                    _a = _b.sent();
                    enqueueSnackbar('Erro ao excluir operador. Tente novamente.', {
                        variant: 'error',
                    });
                    return [3 /*break*/, 6];
                case 5:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var handleRevertExclusion = function (operador) { return __awaiter(void 0, void 0, void 0, function () {
        var confirmed, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, confirm({
                        title: 'Reverter Exclusão',
                        content: "Tem certeza que deseja reverter a exclus\u00E3o do operador \"".concat(operador.nome, "\"?"),
                        confirmationText: 'Reverter',
                        cancellationText: 'Cancelar',
                    })];
                case 1:
                    confirmed = _b.sent();
                    if (!confirmed) {
                        return [2 /*return*/];
                    }
                    _b.label = 2;
                case 2:
                    _b.trys.push([2, 4, 5, 6]);
                    setLoading(true);
                    return [4 /*yield*/, revertOperadorExclusion(processo.processoEdicaoId, operador.id)];
                case 3:
                    _b.sent();
                    enqueueSnackbar('Exclusão revertida com sucesso!', {
                        variant: 'success',
                    });
                    refresh();
                    return [3 /*break*/, 6];
                case 4:
                    _a = _b.sent();
                    enqueueSnackbar('Erro ao reverter exclusão. Tente novamente.', {
                        variant: 'error',
                    });
                    return [3 /*break*/, 6];
                case 5:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var handleSaveOperador = function (operador) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, , 5, 6]);
                    setLoading(true);
                    if (!selectedOperador) return [3 /*break*/, 2];
                    return [4 /*yield*/, updateOperador(selectedOperador.id, operador)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, addOperador(operador)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    setLoading(false);
                    handleCloseModal();
                    refresh();
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var isFormEnabled = !!(processo === null || processo === void 0 ? void 0 : processo.processoEdicaoId) && !disabled;
    return (_jsxs(Box, { children: [_jsx(RequestLoadingIndicator, { loading: loading }), _jsxs(Box, { display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", mb: 1, children: [_jsxs(Box, { children: [_jsx(OrderComponent, { color: "primary" }), _jsx(FilterComponent, { color: "primary" })] }), _jsx(Box, { sx: { display: 'flex', alignItems: 'center' }, children: isFormEnabled && (_jsx(Button, { variant: "contained", color: "primary", startIcon: _jsx(AddIcon, {}), onClick: handleOpenAdd, children: "Adicionar Operador(a)" })) })] }), _jsx(RenderList, { titleField: function (operador) { return operador.nome; }, renderItem: function (operador) { return (_jsxs(Box, { sx: { display: 'flex', flexDirection: 'column', gap: 0.5 }, children: [_jsxs(Typography, { variant: "body2", children: ["CPF: ", formatCpf(operador.cpf)] }), operador.status && (_jsx(Box, { children: _jsx(StatusEdicaoTag, { status: operador.status, size: "small" }) }))] })); }, getStatus: getStatus, actionButtons: [
                    {
                        icon: _jsx(EditIcon, {}),
                        color: 'primary',
                        onClick: handleOpenEdit,
                        tooltip: 'Editar',
                        visible: function (operador) {
                            return isFormEnabled && operador.status !== StatusEdicaoEnum.EXCLUIDO;
                        },
                    },
                    {
                        icon: _jsx(VisibilityIcon, {}),
                        color: 'primary',
                        onClick: handleOpenView,
                        tooltip: 'Visualizar',
                    },
                    {
                        icon: _jsx(DeleteIcon, {}),
                        color: 'error',
                        onClick: handleDelete,
                        tooltip: 'Excluir',
                        visible: function (operador) {
                            return isFormEnabled && operador.status !== StatusEdicaoEnum.EXCLUIDO;
                        },
                    },
                    {
                        icon: _jsx(UndoIcon, {}),
                        color: 'primary',
                        onClick: handleRevertExclusion,
                        tooltip: 'Reverter Exclusão',
                        visible: function (operador) {
                            return isFormEnabled && operador.status === StatusEdicaoEnum.EXCLUIDO;
                        },
                    },
                ] }), _jsx(WizardButtons, { nextClick: nextStep, prevClick: prevStep }), !!modalOperadorOpen && (_jsx(OperadorModalForm, { modo: modalOperadorOpen, open: true, operador: selectedOperador, analise: analise, onClose: handleCloseModal, onSave: handleSaveOperador }))] }));
};
